"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var PREFIX = 'SearchFilter';
var classes = {
    container: "".concat(PREFIX, "-container"),
    label: "".concat(PREFIX, "-label"),
    select: "".concat(PREFIX, "-select"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.container)] = {
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '0px 0.2rem 0px 0.2rem',
            color: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            // Overflow
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
        _b["& .".concat(classes.label)] = {
            paddingLeft: '12px',
            paddingRight: '8px',
            lineHeight: 1,
            whiteSpace: 'nowrap',
        },
        _b["& .".concat(classes.select)] = {
            color: '#000',
            textTransform: 'none',
        },
        _b['& .MuiOutlinedInput-root'] = {
            '& fieldset': {
                border: 'none',
            },
        },
        _b['& .MuiInputBase-input'] = {
            padding: '8px',
        },
        _b);
});
var SearchFilter = function (_a) {
    var icon = _a.icon, options = _a.options, queryKey = _a.queryKey, _b = _a.multiple, multiple = _b === void 0 ? false : _b;
    var _c = (0, react_1.useContext)(SearchVacanciesContext_1.default), query = _c.query, updateQuery = _c.updateQuery;
    var handleChange = function (e) {
        var _a;
        var raw = e.target.value;
        var newValue = typeof raw === 'string' ? raw.split(',') : raw;
        updateQuery((_a = {},
            _a[queryKey] = newValue,
            _a));
    };
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ className: classes.container }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: classes.label }, { children: icon })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ onChange: handleChange, multiple: multiple, fullWidth: true, className: classes.select, value: query[queryKey] }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: option.value }, { children: option.display || option.value }), option.value)); }) }))] })));
};
exports.default = SearchFilter;
